import { atom } from 'jotai';

export type InventoryScanKind = 'PO' | 'ITEM';

export interface IInventoryScanResult {
  kind: InventoryScanKind;
  data: any;
}

export const inventoryScanResultAtom = atom<IInventoryScanResult | null>(null);
export const inventoryScanLoadingAtom = atom<boolean>(false);


